import React from "react";

const WordContext = React.createContext({});

export default WordContext;
